import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Tab, SvgIcon, IconButton } from '@mui/material';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg';
import ResponsiveImage from '../ResponsiveImage';
import { StyledTabs, StyleTabPanel, Bullets, StyledTabImageLabel } from './DS_TabsStyles';

function TabPanel(props) {
  const { children, value, index, className, cardsAnimation, animationClass, ...other } = props;

  return (
    <StyleTabPanel
      className={cardsAnimation ? `${animationClass} ${className}` : className}
      role="tabpanel"
      hidden={cardsAnimation ? false : value !== index}
      id={`simple-tabpanel-${index}`}
      aria-label={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={`styled-mui-tab-panel-box ${className}`}>{children}</Box>}
    </StyleTabPanel>
  );
}

const DS_Tabs = ({
  array,
  renderItem,
  className,
  bullets = false,
  onChange,
  defaultValue,
  cardsAnimation = false,
  secondTabActive = false,
  scrollable = false,
}) => {
  const [value, setValue] = useState(secondTabActive ? 1 : 0);
  const TabTitle = ({ bullets, element }) => {
    let subTitle;
    let title = element.type ? element.type : element.prices[0].type;
    if (title && title.match(/\((.*?)\)/)) {
      subTitle = title.substring(title.indexOf('('), title.indexOf(')') + 1);
      title = `${title.split('(')[0]}\n${subTitle}`;
    }
    return bullets ? <Bullets></Bullets> : title;
  };

  const handleChange = (event, newValue) => {
    if (onChange) onChange(event, newValue);
    setValue(newValue);
  };

  useEffect(() => {
    if (typeof defaultValue === 'undefined') return;
    setValue(defaultValue);
  }, [defaultValue]);

  const scrollableStyles = scrollable ? 'scrollable' : null;

  function MyScrollButton({ direction, ...props }) {
    if (props.disabled) return null; // Do not render the button if scrolling is not possible

    return (
      <IconButton {...props} data-disabled={props.disabled}>
        {direction === 'left' ? (
          <SvgIcon component={ArrowLeft} inheritViewBox />
        ) : (
          <SvgIcon component={ArrowRight} inheritViewBox />
        )}
      </IconButton>
    );
  }

  return (
    <>
      <Box data-test="box-tabs">
        <StyledTabs
          $bullets={bullets}
          data-test="tabs-wrapper"
          value={value}
          onChange={handleChange}
          aria-label="tabs"
          className={`styled-mui-tabs ${className} ${scrollableStyles}`}
          variant={scrollable ? 'scrollable' : 'standard'}
          scrollButtons="auto"
          ScrollButtonComponent={MyScrollButton}
        >
          {array?.map((element, index) => (
            <Tab
              id={'tab' + index}
              data-test="tab"
              key={`tab-key-${element.id}`}
              className={`styled-mui-tab ${className}`}
              label={
                element.image ? (
                  <StyledTabImageLabel>
                    {element.image && <ResponsiveImage {...element.image} gatsbyImageOptions={{ loading: 'eager' }} />}
                  </StyledTabImageLabel>
                ) : (
                  element.label || <TabTitle bullets={bullets} element={element} />
                )
              }
            />
          ))}
        </StyledTabs>
      </Box>
      <div className={`styled-mui-tabs-panel ${className}`}>
        {array?.map((element, index) => (
          <TabPanel
            value={value}
            index={index}
            key={`tabpanel-key-${element.id}`}
            className={className}
            cardsAnimation={cardsAnimation}
            animationClass={value === index ? `appear` : `disappear`}
          >
            {renderItem(element)}
          </TabPanel>
        ))}
      </div>
    </>
  );
};

export default DS_Tabs;

DS_Tabs.propTypes = {
  bullets: PropTypes.bool,
};
